import { createSelector } from "reselect";

export const selectPayment = (state) => state.payment;

export const selectCurrentPlan = createSelector(
  [selectPayment],
  (payment) => payment?.currentPlan || "free"
);

export const selectQuotas = createSelector(
  [selectPayment],
  (payment) => payment?.quotas || null
);

export const selectSubscription = createSelector(
  [selectPayment],
  (payment) => payment?.subscription || null
);

export const selectPaymentHistory = createSelector(
  [selectPayment],
  (payment) => payment?.history || []
);

export const selectCheckout = createSelector([selectPayment], (payment) => ({
  url: payment?.checkoutUrl || null,
  plan: payment?.checkoutPlan || null,
  loading: !!payment?.loadingCheckout,
  error: payment?.checkoutError || null,
}));
